import {Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: 'item.html',
  styleUrls: ['item.scss']
})
export class ButtonComponent implements OnInit {
  @Input() icon = '';
  @Input() textButton = '';
  @Input() color: 'dark' | 'light-blue' | 'gray' | 'white'  = 'dark';
  @Input() small = false;
  @Input() medium = false;
  @Input() disabled = false;
  @Input() cartButton = false;
  @Input() printSectionId = '';
  @Input() loading = false;

  @Output() clickButton: EventEmitter<void> = new EventEmitter();

  ngOnInit() {}

  getIconUrl() {
    return this.icon ? `/assets/icons/${this.icon}.svg` : null;
  }

  onClick() {
    this.clickButton.emit();
  }

}
